export default __webpack_public_path__ + "static/media/logonew.626c79d7.PNG";